<div class="aggregate-info-window">
  <!-- TOPOS-4588: StaoCache sometimes returns aggregates with the name "null" e.g. when searching for Bern. In these cases we don't show the name. -->
  <h5 class="fw-bold" *ngIf="poi.name !== undefined && poi.name !== 'null'">{{poi?.name}}</h5>
  <p class="font-size-15">{{poi?.count}}
    <span *ngIf="poi.count === 1" translate>map.aggregateinfowindow.result</span>
    <span *ngIf="poi.count !== 1" translate>map.aggregateinfowindow.results</span>
  </p>
</div>